import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect } from './SearchResultLawyerContainer';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { AddEntityWatcherButton } from '../../../../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import {
  SearchCard,
  FollowContainer,
  SearchCardList,
} from '../../results-card';
import { LawyerCardTitle } from '../../../../../lawyer/card/LawyerCardTitle';
import { LawyerKeywords } from './LawyerKeywords';
import { QueryParamsType } from '../../../../state/reducers/queryParams.types';
import {
  EntitiesList,
  EntitiesListItem,
} from '../../../../../components/entities-card/EntitiesList';
import { UserContextType } from '../../../../../user/user.types';
import { withUser } from '../../../../../user/UserContext';
import { LawyerHit } from '../../../../search.types';

type Props = {
  lawyer: LawyerHit;
  originalQueryKey: QueryParamsType['originalQueryKey'];
} & UserContextType &
  WithRestrictedModalProps;

class RawSearchResultLawyer extends React.Component<Props> {
  protectFeature = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const { accessPremium, openRestrictedModal } = this.props;
    if (!accessPremium) {
      event.preventDefault();
      openRestrictedModal('excerpt_results_law');
    }
  };

  onButtonClick = (isAdded: boolean) => {
    const { lawyer } = this.props;
    if (isAdded) {
      doctrineAnalytics('Search LawyerWatchClicked', {
        lawyer_id: lawyer.lawyerId,
      });
    }
  };

  render() {
    const { lawyer, openRestrictedModal, originalQueryKey } = this.props;

    return (
      <SearchCard>
        <div>
          <LawyerCardTitle
            href={buildUrlWithParameters(lawyer.url, {
              original_query_key: originalQueryKey,
            })}
            onClick={this.protectFeature}
          >
            {lawyer.name}
          </LawyerCardTitle>
          {lawyer.isVerified && (
            <div className="search-results-lawyer__right__verify">
              <i className="material-icons icons__verified_user search-results-lawyer__right__verify__icon green" />
              <span className="search_card_right__lawyer__verify__label green">
                <FormattedMessage id="search/components/search-results/lawyer-lawfirm/lawyer/SearchResultLawyer.tsx/1" />
              </span>
            </div>
          )}
          <SearchCardList>
            <EntitiesList>
              {lawyer.barreau !== 'Avocat aux conseils' && (
                <EntitiesListItem left="Barreau" right={lawyer.barreau} />
              )}
              {lawyer.barreau === 'Avocat aux conseils' && (
                <EntitiesListItem left="Ordre des" right={lawyer.barreau} />
              )}
              {!!lawyer.sermentDate && (
                <EntitiesListItem
                  left="Prestation de serment"
                  right={lawyer.sermentDate}
                />
              )}
            </EntitiesList>
          </SearchCardList>
        </div>

        <LawyerKeywords keywords={lawyer.keywords} />
        <FollowContainer>
          <AddEntityWatcherButton
            queryParams={{ lid: lawyer.lawyerId, q: lawyer.name }}
            uniqueId={lawyer.lawyerId}
            onButtonClick={this.onButtonClick}
            restrict={() => openRestrictedModal('want_to_follow_lawyer')}
            source="lawyer_results"
            secondary
          />
        </FollowContainer>
      </SearchCard>
    );
  }
}

export const SearchResultLawyer = withUser(
  withRestrictedModal(Connect(RawSearchResultLawyer)),
);
